import type {
  FormDefinitionOfflineBundleResponse,
  FormRequest,
  FormResponse,
  IStateMachineOfFormStateEnum,
  TransitionRequest,
} from 'src/api/ProactApiClient';

// The API client may only be imported by src/redux and src/offline, so the
// forms replay calls are injected; see src/redux/queries/formsOfflineRegistration.ts.
export interface FormsOfflineApi {
  getOfflineBundle: () => Promise<FormDefinitionOfflineBundleResponse>;
  createForm: (request: FormRequest) => Promise<FormResponse>;
  getForm: (id: number) => Promise<FormResponse>;
  getStateMachine: () => Promise<IStateMachineOfFormStateEnum>;
  transitionForm: (
    id: number,
    request: TransitionRequest
  ) => Promise<FormResponse>;
}

let boundApi: FormsOfflineApi | undefined;

export const bindFormsOfflineApi = (api: FormsOfflineApi): void => {
  boundApi = api;
};

const api = (): FormsOfflineApi => {
  if (!boundApi) {
    throw new Error(
      'Forms offline API is not bound — import src/redux/queries/formsOfflineRegistration first.'
    );
  }
  return boundApi;
};

export const getOfflineBundle = (): Promise<FormDefinitionOfflineBundleResponse> =>
  api().getOfflineBundle();

export const createForm = (request: FormRequest): Promise<FormResponse> =>
  api().createForm(request);

export const getForm = (id: number): Promise<FormResponse> => api().getForm(id);

export const getStateMachine = (): Promise<IStateMachineOfFormStateEnum> =>
  api().getStateMachine();

export const transitionForm = (
  id: number,
  request: TransitionRequest
): Promise<FormResponse> => api().transitionForm(id, request);
